<div class="row">
  <div class="field">
    <div id="dismissible-tag" class="tag-list">
      @for (field of selectedFields$ | async; track trackByKey($index, field)) {
        <span
          class="tag is-dismissible lm-slide-enter"
          style="padding-right: 0px"
          id="{{ ViewerConstants.Tag.automationId + '_' + field.key }}"
          [attr.data-automation-id]="ViewerConstants.Tag.automationId + '_' + field.key"
          title="{{ field.key }} ({{ field.value }})"
          ><span>{{ field.value }}</span>
          <button style="background-color: transparent" soho-button="icon" icon="close-small" (click)="onRemoveField(field.key)">Remove Field</button>
        </span>
      }
    </div>
  </div>
</div>
